/*
  * Executes the provided callback thanks to <code>global.setInterval</code>.
  *
  * @param {function()} callback
  * @param {number} frequency how many times per second we want to execute the callback
  * @constructor
  */

function IntervalRunner(callback, desiredFrequency, maxIterations = Infinity) {
  let timeoutId = null;
  let running = false;
  let iteration = 1;
  const timeBetween = 1000 / desiredFrequency;

  const loop = () => {
    if (!running || iteration > maxIterations) {
      return;
    }
    iteration += 1;
    timeoutId = setTimeout(loop, timeBetween);
    callback();
  };

  this.start = () => {
    if (running) {
      return;
    }
    running = true;
    setTimeout(loop, timeBetween);
  };

  this.stop = () => {
    global.clearTimeout(timeoutId);
    running = false;
  };
}

module.exports = IntervalRunner;



// WEBPACK FOOTER //
// ./src/js/ot/interval_runner.js